import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/rec/top/list',
    method:'get',
    params:params
  })
}
export function deleteRecTop(data) {
  return request({
    url:'/rec/top/delete',
    method:'post',
    data:data
  })
}
export function createRecTop(data) {
  return request({
    url:'/rec/top/create',
    method:'post',
    data:data
  })
}
export function getRecTop(id) {
  return request({
    url:'/rec/top/'+id,
    method:'get',
  })
}

export function updateRecTop(id,data) {
  return request({
    url:'/rec/top/update/'+id,
    method:'post',
    data:data
  })
}
export function updateRecTops(data) {
  return request({
    url:'/rec/top/updates',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/top.js